import { type FunctionComponent } from 'react';
import { configureRoute } from '../../../utils/routes/configure-route';
import { CreateAccountForm } from '../../components/account-components/create-account-form/create-account-form.component';
import { PageContainer } from '../../components/common-components/page/page-container/page-container.component';
import { ACCOUNT_CREATE_LINK, ACCOUNT_LOGIN_LINK, HOMEPAGE_LINK, PRO_SIGNUP_LINK } from '../../constants/links';
import { CREATE_ACCOUNT_PAGE_DESCRIPTION_META, CREATE_ACCOUNT_PAGE_TITLE_META } from '../../constants/meta';
import { isValidReturnTo } from '../../helpers/login/login.helpers';
import { useTrackPageView } from '../../hooks/analytics/analytics.hooks';
import { useNavigation } from '../../hooks/navigation/navigation.hooks';
import { useRouterLocation } from '../../hooks/routing/location.hook';

const PAGE_NAME = 'account:create';

export const CreateAccountPage: FunctionComponent = () => {
	const navigate = useNavigation();
	const { search } = useRouterLocation();

	const onSuccess = (isProAccount) => {
		const searchParams = new URLSearchParams(search);
		let returnTo = searchParams.get('returnto');
		returnTo = isValidReturnTo(returnTo) ? returnTo : null;

		navigate(isProAccount ? PRO_SIGNUP_LINK : returnTo || HOMEPAGE_LINK);
	};
	useTrackPageView({ pageName: PAGE_NAME }, { page: PAGE_NAME });
	return (
		<PageContainer
			canonicalURL={ACCOUNT_CREATE_LINK}
			pageTitle={CREATE_ACCOUNT_PAGE_TITLE_META}
			metaDescription={CREATE_ACCOUNT_PAGE_DESCRIPTION_META}>
			<div className="w-100 w-50-ns center">
				<CreateAccountForm onCancel={() => navigate(ACCOUNT_LOGIN_LINK)} onSuccess={onSuccess} />
			</div>
		</PageContainer>
	);
};

export const RoutedCreateAccount = configureRoute({ path: ACCOUNT_CREATE_LINK }, CreateAccountPage);
